import type { Session } from './types';

export function canOfferUpdate(updateReady: boolean, activeSession: Session | null | undefined) {
  return updateReady && !activeSession;
}
